import { IwocaLogo } from '@iwoca/orion';
import { clsx } from 'clsx';

import styles from './PoweredByIwoca.module.css';
import { useGetBrandingQuery } from '../../lendingApi/lendingApiQueries';

type TProps = {
  whiteLogo?: boolean;
};

const PoweredByIwoca = ({ whiteLogo }: TProps) => {
  const { branding, isBrandingLoading } = useGetBrandingQuery();

  if (isBrandingLoading) {
    return null;
  }

  const partnerBranded = branding?.signup_branding_type === 'partner';
  return (
    <div
      className={styles.poweredByIwoca}
      data-testid={whiteLogo ? 'white-iwoca-logo' : undefined}
    >
      {partnerBranded && (
        // "Powered by" is intentionally the same in UK and DE
        <p className={styles.poweredByIwocaText}>Powered by</p>
      )}
      <IwocaLogo
        className={clsx(
          {
            [styles.iwocaBranded]: !partnerBranded,
            [styles.whiteLogo]: whiteLogo,
          },
          styles.iwocaLogo,
        )}
      />
    </div>
  );
};

export default PoweredByIwoca;
